import translate from './address-selector.language';
class AddressSelectorController {
	constructor() {
		this.translate = translate;
	}
	/**
	 * Initialization state props
	 */
	$onInit() {
		if(!this.searchFields) this.searchFields = ['city','zip'];

		if(!this.doctorList) this.doctorList = [];

		if(!this.minCharacter) this.minCharacter = 1;

		if(!this.activateOnFocus) this.activateOnFocus = false;

		if(!this.displayField) this.displayField = "city";
	}

	resetAddressSelector(){
		if (angular.isFunction(this.onSelect))
			this.onSelect({
				$event: {
					value:null
				}
			});
	}
	
	/*
     * Change selected address
     */
	setSelectedAddress({value}) {
		if (angular.isFunction(this.onSelect))
			this.onSelect({
				$event: {
					value
				}
			});
	}
}

export default AddressSelectorController;


// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/components/address-selector/address-selector.controller.js